import React, { FC, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Setting } from '../App';
import classes from '../asset/css/main.module.css';
import { Cancel } from '../components/subscription-cancel/Cancel';
import { useSubscriptionCancel } from '../hooks/use-subscription-cancel';
import { useCancelSurvey } from '../hooks/use-cancel-survey';
import { useRecentlyContracted } from '../hooks/use-recently-contracted';
import { useHistory } from 'react-router-dom';
import { CancelSurveyEnable } from '../types/api/subscriptions-api-type';
import goAndBackClasses from '../asset/css/go-and-back.module.css';

export const SubscriptionCancel: FC<{ setting: Setting }> = ({ setting }) => {
  const history = useHistory();
  const { subscriptionCancel } = useSubscriptionCancel(setting);
  const { cancelSurvey } = useCancelSurvey(setting);
  const { recentlyContracted } = useRecentlyContracted(setting);

  const [isRecentlyContracted, setIsRecentlyContracted] = useState<boolean>(true);
  const [cancelPossibleDate, setCancelPossibleDate] = useState('8日後');


  const [survey, setSurvey] = useState<CancelSurveyEnable>({
    cancelSurveyEnable: false,
    cancelSurveyLeadText: '',
    cancelSurveyRequire: false,
    cancelSurveyExtraField: false,
    reasons: [],
  });

  
  const root = useRef<HTMLDivElement>(null);
  useEffect(() => {
    setting.resize(root.current?.clientHeight ?? 0);
  }, [setting, root.current?.clientHeight, isRecentlyContracted, survey]);

  useEffect(() => {
    cancelSurvey(
      (success) => setSurvey(success),
      (message) => console.log(message)
    );
    recentlyContracted(
      (flag) => { console.log(flag);setIsRecentlyContracted(flag)},
      (cancelDate) => {console.log(cancelDate); setCancelPossibleDate(cancelDate)},
      (message) => console.log(message)
    );
  }, [setting]);

  return (
    <>
      <div className={classes.mypage_subsc_container} ref={root}>
        { isRecentlyContracted ? (
        <>
          <h4 className="medium-up--text-center">BOXプランの解約</h4>
          <div className='medium-up--text-center'>
            【{cancelPossibleDate}】から解約が可能となります。<br />
            <br />
            商品のお届け期間※は、解約受付を控えさせていただいております。<br />
            ※ご注文日から8日間<br />
            <br />
            最短でのお届けを指定いただいたお客様は恐れ入りますが、{cancelPossibleDate}以降にご確約をお願い致します。<br />
            何卒、ご容赦いただけますと幸いです。<br />
            <br />
            ※お手続き忘れの無いよう、次回ご注文確定日の2・7日前にメールやLINEでリマインド連絡を致します<br />
          </div>
          <div className={goAndBackClasses.mypage_subsc_go_and_back_buttons}>
            <Link to="/">もどる</Link>
          </div>
        </>
        ) : (
          <Cancel
            subscriptionCancelFunc={(surveyAnswer) => {
              subscriptionCancel(
                () => {
                  history.push('/cancel/complete');
                },
                (message) => console.log(message),
                surveyAnswer
              );
            }}
            survey={survey}
          />
        ) }
      </div>
    </>
  );
};
